module.exports = __webpack_public_path__ + "static/media/N13.06d0300c.jpg";